var map = {
	"./404.svg": "OCSz",
	"./bug.svg": "hFu9",
	"./chart.svg": "ASwc",
	"./clipboard.svg": "riAQ",
	"./component.svg": "Vb4V",
	"./dashboard.svg": "BiSv",
	"./documentation.svg": "zzy8",
	"./drag.svg": "kbtv",
	"./edit.svg": "m7lW",
	"./education.svg": "9iJq",
	"./email.svg": "dMYP",
	"./example.svg": "iczt",
	"./excel.svg": "yciL",
	"./exit-fullscreen.svg": "ZnP4",
	"./eye-open.svg": "KA0E",
	"./eye.svg": "QkiN",
	"./form.svg": "d4wG",
	"./fullscreen.svg": "ga4y",
	"./guide.svg": "yHE3",
	"./icon.svg": "BcKP",
	"./international.svg": "Vh3Z",
	"./language.svg": "Ld/A",
	"./link.svg": "3LYA",
	"./list.svg": "zAcj",
	"./lock.svg": "vsLB",
	"./message.svg": "rTF8",
	"./money.svg": "OMLX",
	"./nested.svg": "3p9Q",
	"./password.svg": "HSHq",
	"./pdf.svg": "URLw",
	"./people.svg": "hytI",
	"./peoples.svg": "bYcQ",
	"./qq.svg": "iVsK",
	"./search.svg": "Kya+",
	"./shopping.svg": "OQUu",
	"./size.svg": "CQgd",
	"./skill.svg": "tCqS",
	"./star.svg": "0r69",
	"./tab.svg": "aCBq",
	"./table.svg": "0NQx",
	"./theme.svg": "S6m5",
	"./tree-table.svg": "wjsn",
	"./tree.svg": "x2Nn",
	"./user.svg": "2uFT",
	"./wechat.svg": "9mUm",
	"./zip.svg": "ncs+"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ReTJ";